<template lang="pug">
  v-card
    v-toolbar.elevation-0(height="45" color="gray")
      v-toolbar-title                  
        h1.subheading {{ $t('labels.dueDate') }}
      v-spacer
      div(v-if="!service.lastinvoicedateTime")
        v-btn(small color='teal' dark, icon @click="createInvoice(location)" v-if='$moment(service.dueDate).format("YYYY-MM-DD") <= $moment().add(3, "d").format("YYYY-MM-DD")')
          v-icon(small) add 
      v-btn(small color='pink' dark, icon @click="dialog = true" v-if="checkRightStatus(24)")
        v-icon(small) edit
    v-card-text.pa-0
      v-card(color="blue darken-1" dark)
        v-card-text
          v-layout(column)
            v-layout(row wrap)
              v-flex.font-weight-regular
                div.text-xs-center
                  span.font-weight-medium {{ service.dueDate }} |
                  span
                    v-chip(small v-if="dueDateCount > minDay")
                      span.font-weight-medium {{ dueDateCount }} days
                    v-chip(small color="#ffd0d2" text-color='#ff3840' v-else)
                      span.font-weight-medium {{ dueDateCount }} days
    v-dialog(v-model='dialog', persistent max-width='350')
      v-card
        v-toolbar.elevation-0(height="45" color="gray")
          v-toolbar-title
            h1.subheading {{ $t('labels.dueDate') }}
          v-spacer
          span(v-if="locationDueDate")
            v-chip(small v-if="NewDueDateCount > minDay")
              span.font-weight-medium {{ NewDueDateCount }} days
            v-chip(small color="#ffd0d2" text-color='#ff3840' v-else)
              span.font-weight-medium {{ NewDueDateCount }} days
        v-card-text
          v-layout(row v-if="locationDueDate")
            DateTimePicker(:showIcon="false"
              :range="false" autoSubmit
              :clearable="false"
              :hideTime="true"
              label="Due Date"
              ref="dateTimePicker"
              v-on:input="setDate"
              :initStartDate="$moment(locationDueDate)" 
              :noFuture="true")
          
        v-divider
        v-card-actions
          v-spacer
          v-btn(color='info', flat, @click='close') Close
          v-btn(color='info'  @click='save') Save

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import invoiceService from "../../../Invoice/service.js";
import DateTimePicker from "../../../Global/components/DateTimePicker";
import locationService from "../../service.js";

export default {
  props: {
    service: {
      default: {}
    },
    minDay: {
      default: 5
    }
  },
  data() {
    return {
      dialog: false,
      locationDueDate: null
    };
  },
  components: {
    DateTimePicker
  },
  computed: {
    ...mapGetters("global", ["checkRightStatus"]),
    ...mapGetters("location", ["location"]),
    dueDateCount() {
      return this.$moment(this.service.dueDate).diff(
        this.$moment().format("MM/DD/YYYY"),
        "day"
      );
    },
    NewDueDateCount() {
      return this.$moment(this.locationDueDate).diff(
        this.$moment().format("MM/DD/YYYY"),
        "day"
      );
    }
  },
  watch: {
    dialog(val) {
      this.locationDueDate = _.clone(this.service.dueDateV2);
    }
  },
  mounted() {
    console.log('service', this.service)
    // this.$events.listen('refreshDueDate', data => this.getList());
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    close() {
      this.locationDueDate = null;
      this.dialog = false;
    },
    save() {
      this.updateProductRelation({ dueDateV2: this.locationDueDate }).then(
        result => {
          this.close();
        }
      );
    },
    setDate(val) {
      this.locationDueDate = val;
    },
    updateProductRelation(data) {
      return locationService
        .updateProductRelation(
          this.location.storeID,
          this.service.serviceID,
          data
        )
        .then(result => {
          this.$swal
            .mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000
            })
            .fire({
              type: "success",
              title: "Update Successfully"
            });
          this.setLocation(this.location.storeID);
        });
    },
    createInvoice(data) {
      this.$swal({
        title: "Are you sure?",
        html: `You like to create invoice for <strong>${data.businessName}</strong>. Invoice will send to ${data.invoiceEmail}`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Create"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return invoiceService
            .renewInvoice(data.storeID, this.service.serviceID)
            .then(response => {
              console.log("response", response);
              if (response.data) {
                this.$swal(
                  "Created!",
                  "Invoice was created successfully",
                  "success"
                );
                this.$Progress.finish();
                this.$events.$emit("refreshInvoiceList");
                this.setLocation(this.location.storeID);
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: error.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    }
  }
};
</script>
